var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbarassedShameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 73,
    viewBox: "0 0 69 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2982 12.9043C32.2982 12.9043 31.3889 18.2048 25.9332 19.2817C25.9332 19.2817 21.3748 20.1671 18.8145 15.5366C18.8145 15.5366 25.5982 19.844 32.2982 12.9043Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 29.2248C13.7539 29.2248 15.7041 22.1893 23.2057 21.4833C23.2057 21.4833 29.4869 20.909 32.3105 27.5018C32.3105 27.5018 23.7441 20.7654 13.7539 29.2248Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1113 12.9043C35.1113 12.9043 36.0206 18.2048 41.4763 19.2817C41.4763 19.2817 46.0347 20.1671 48.5951 15.5366C48.5951 15.5366 41.8113 19.844 35.1113 12.9043Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2578 29.2248C55.2578 29.2248 53.3076 22.1893 45.806 21.4833C45.806 21.4833 39.5247 20.909 36.7012 27.5018C36.7012 27.5018 45.2676 20.7654 55.2578 29.2248Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0263 44.5154C27.0966 44.5154 30.3963 39.9727 30.3963 34.369C30.3963 28.7653 27.0966 24.2227 23.0263 24.2227C18.9559 24.2227 15.6562 28.7653 15.6562 34.369C15.6562 39.9727 18.9559 44.5154 23.0263 44.5154Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2475 42.0976C26.2827 42.0976 27.9325 39.8262 27.9325 37.0244C27.9325 34.2225 26.2827 31.9512 24.2475 31.9512C22.2123 31.9512 20.5625 34.2225 20.5625 37.0244C20.5625 39.8262 22.2123 42.0976 24.2475 42.0976Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9735 44.5154C50.0439 44.5154 53.3435 39.9727 53.3435 34.369C53.3435 28.7653 50.0439 24.2227 45.9735 24.2227C41.9032 24.2227 38.6035 28.7653 38.6035 34.369C38.6035 39.9727 41.9032 44.5154 45.9735 44.5154Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2065 42.0976C49.2417 42.0976 50.8915 39.8262 50.8915 37.0244C50.8915 34.2225 49.2417 31.9512 47.2065 31.9512C45.1713 31.9512 43.5215 34.2225 43.5215 37.0244C43.5215 39.8262 45.1713 42.0976 47.2065 42.0976Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1876 25.3496C60.1876 25.3496 53.2484 36.872 60.1876 36.872C67.1269 36.872 60.1876 25.3496 60.1876 25.3496Z",
    fill: "#00ADEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8184 65.2156C14.8184 65.2156 22.8105 50.3071 24.7607 53.6812C24.7607 53.6812 33.4468 41.9674 36.8925 46.7654C40.3382 51.5634 33.4468 60.6808 33.4468 60.6808C33.4468 60.6808 36.2584 59.1852 35.9473 61.3509C35.6362 63.5165 22.5234 71.8682 22.5234 71.8682",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8184 65.2156C14.8184 65.2156 22.8105 50.3071 24.7607 53.6812C24.7607 53.6812 33.4468 41.9674 36.8925 46.7654C40.3382 51.5634 33.4468 60.6808 33.4468 60.6808C33.4468 60.6808 36.2584 59.1852 35.9473 61.3509C35.6362 63.5165 22.5234 71.8682 22.5234 71.8682",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1932 65.2156C54.1932 65.2156 46.2011 50.3071 44.2509 53.6812C44.2509 53.6812 35.5648 41.9674 32.1191 46.7654C28.6734 51.5634 35.5648 60.6808 35.5648 60.6808C35.5648 60.6808 32.7532 59.1852 33.0643 61.3509C33.3753 63.5165 46.4882 71.8682 46.4882 71.8682",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1932 65.2156C54.1932 65.2156 46.2011 50.3071 44.2509 53.6812C44.2509 53.6812 35.5648 41.9674 32.1191 46.7654C28.6734 51.5634 35.5648 60.6808 35.5648 60.6808C35.5648 60.6808 32.7532 59.1852 33.0643 61.3509C33.3753 63.5165 46.4882 71.8682 46.4882 71.8682",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbarassedShameIcon);
export default __webpack_public_path__ + "static/media/embarassed-shame-icon.c461b6d0a1c271ff3dff91c8c9585e68.svg";
export { ForwardRef as ReactComponent };